import { createFileRoute } from '@tanstack/react-router';
import { SkillsPage } from '../../features/settings/components/skills-page.js';

export const Route = createFileRoute('/admin/skills')({ component: SkillsPage });
